import ExceptionBase from "@/dto/exceptions/exceptionBase";
export default class ForbiddenValidationException extends ExceptionBase {
  constructor(data) {
    super(data);
  }
}
